import { render, staticRenderFns } from "./YingHaoBlackTitle.vue?vue&type=template&id=70acfb6c&scoped=true"
import script from "./YingHaoBlackTitle.vue?vue&type=script&lang=js"
export * from "./YingHaoBlackTitle.vue?vue&type=script&lang=js"
import style0 from "./YingHaoBlackTitle.vue?vue&type=style&index=0&id=70acfb6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70acfb6c",
  null
  
)

export default component.exports